import React from "react";
import { MdWarning } from "react-icons/md";

const Popup = ({ show, onSkip, onFillDetails }) => {
  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-gray-400 bg-opacity-50 z-50">
    //   <div className="bg-white rounded-lg shadow-lg p-6 w-[50%] lg:w-[36%] text-center">
    //     <div className="text-yellow-500 mb-4">
    //       <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m0-4h.01M12 2a10 10 0 110 20 10 10 0 010-20z" />
    //       </svg>
    //     </div>
    //     <p className="mb-6">Please fill in the details to move to next section / click on skip section</p>
    //     <div className="flex justify-center">
    //       <button
    //         className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-8"
    //         onClick={onSkip}
    //       >
    //         Skip Section
    //       </button>
    //       <button
    //         className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded"
    //         onClick={onFillDetails}
    //       >
    //         Fill details
    //       </button>
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-[#F3F3F3] py-6  px-10 rounded-lg shadow-lg  w-[85%] md:w-[40%] lg:w-[40%] ">
        <div className="flex flex-col items-center">
          <MdWarning className="text-6xl text-[#ff6b00]" />
          <p className="  mt-4">
            Please fill in the details to move to the next section / click on
            skip section{" "}
          </p>{" "}
        </div>
        <div className=" mt-5 whitespace-nowrap w-full flex  justify-between ">
          <button className="underline" onClick={onSkip}>
            Skip Section
          </button>
          <button
            className="text-white border-1   bg-[#ff6b00] px-6 py-2 rounded-lg  "
            onClick={onFillDetails}
          >
            Fill details
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
